module.exports = __webpack_public_path__ + "img/norway-diabetes-mellitus-male.fb57ba17.png";